import React from 'react';
import { ApolloQueryResult } from 'apollo-client';
import { ListTimelineEntriesQuery } from '../../../types/__generated__';

interface TimelineContext {
  refetch: RefetchFn;
  fetchNextPage: () => Promise<void>;
}

export const TimelineContext = React.createContext<TimelineContext | null>(
  null,
);

type RefetchFn = () => Promise<ApolloQueryResult<ListTimelineEntriesQuery>>;
